import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import VideoCameraTwoToneSvg from "@ant-design/icons-svg/es/asn/VideoCameraTwoTone";
import AntdIcon from '../components/AntdIcon';
var VideoCameraTwoTone = function VideoCameraTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: VideoCameraTwoToneSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(VideoCameraTwoTone);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'VideoCameraTwoTone';
}
export default RefIcon;